export default "__VITE_ASSET__CnlfFjDy__"